import cn from 'classnames';
import React from 'react';

import styles from './LearnMoreContainer.css';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  mobileResize?: number;
}

export const LearnMoreContainer = ({
  children,
  className,
  ...props
}: Props) => {
  return (
    <div
      className={cn(styles.LearnMoreContainer, className)}
      data-test="widget-container"
      {...props}
    >
      {children}
    </div>
  );
};
